import cpanelIcon from "assets/images/icons/cpanel.png";
import directAdminIcon from "assets/images/icons/directadmin.png";
import { getPanelName, vhpRemovePanelName } from "helpers/helper";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import collapseIcon from "../../../assets/images/icons/vcollapse.png";

const VCHOrder = ({ 
	currentProduct, 
	hostingProduct, 
	setHostingProduct,
}) => {
  const { name } = currentProduct.current;
  const removePanelStr = vhpRemovePanelName(name);
  const [selectedPanel, setSelectedPanel] = useState({
    name: null,
    panel: null,
    backup: null,
  });

  const isSingapore = selectedPanel.panel?.toLowerCase().includes("singapura");
  const [changeProduct, setChangeProduct] = useState(false);

  useEffect(() => {
    if (selectedPanel.panel === "cpanel" || selectedPanel.panel === "cPanel") {
      const cpanelArr = hostingProduct.productPanel[0].cpanel;
      // console.log("cpanelArr", cpanelArr);
      const cpanelFiltered = cpanelArr.find((item) => {
        if (selectedPanel.backup) {
          return item.name.includes(`${selectedPanel.name} + Backup Harian`);
        } else {
          return item.name.includes(selectedPanel.name);
        }
      });
      // console.log("cpanelFiltered: ", cpanelFiltered);
      if (cpanelFiltered) {
        setHostingProduct({
          type: "SET_CURRENT_PID",
          payload: cpanelFiltered.pid,
        });
      }
    }
    if (
      selectedPanel.panel === "directAdmin" ||
      selectedPanel.panel === "DirectAdmin"
    ) {
      const directAdminArr = hostingProduct.productPanel[1].directAdmin;
      // console.log("directAdminArr: ", directAdminArr);
      const directAdminFiltered = directAdminArr.find((item) => {
        if (selectedPanel.backup) {
          return item.name.includes(`${selectedPanel.name} + Backup Harian`);
        } else {
          return item.name.includes(selectedPanel.name);
        }
      });
      if (directAdminFiltered) {
        setHostingProduct({
          type: "SET_CURRENT_PID",
          payload: directAdminFiltered.pid,
        });
      }
    }
  }, [hostingProduct.productPanel, selectedPanel, setHostingProduct]);

  useEffect(() => {
    setSelectedPanel({
      name,
      panel: getPanelName(name),
      backup: false,
    });
  }, [name]);

  const panelHandler = (e) => {
    setSelectedPanel({
      ...selectedPanel,
      name: e.target.value,
      panel: e.target.id,
    });
  };

  const addBackupHandler = (e) => {
    if (e.target.value === " + Backup Harian") {
      setSelectedPanel({
        ...selectedPanel,
        backup: true,
      });
    } else {
      setSelectedPanel({
        ...selectedPanel,
        backup: false,
      });
    }
  };
  
  const TooltipInfo = ({ msg, bgColor, placement }) => {
    return (
      <OverlayTrigger
        placement={placement ? placement : "bottom"}
        overlay={<Tooltip>{msg ? msg : "Put message please"}</Tooltip>}
      >
        <span
          className="d-inline-block px-2 py-0 ms-1 fw-bold text-qw-primary flex-grow-0"
          style={{
            backgroundColor: bgColor ? bgColor : "#959595",
            border: "1px solid #ee4d30",
            cursor: "pointer",
            borderRadius: "50%",
            fontSize: "12px",
            flexGrow: 0,
          }}
        >
          i
        </span>
      </OverlayTrigger>
    );
  };
  
  const PanelRadioButton = ({ 
    id,
    value,
    checked,
    onChange,
    icon,
    disabled,
  }) => (
    <div className="form-check">
      <input
        type="radio"
        name="panel"
        className="form-check-input me-3"
        id={id}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id} className="form-check-label">
        <img src={icon} alt={`${id}.png`} />
      </label>
    </div>
  );
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <button
            className="btn btn-link text-decoration-none p-0 text-qw-primary small"
            onClick={() => setChangeProduct(!changeProduct)}
            style={{
              fontSize: "13px",
            }}
          >
            {changeProduct ? "Sembunyikan" : ""} Pilihan Panel{" "}
            <CollapseIcon
              className="ms-2"
              style={{
                rotate: changeProduct ? "0deg" : "-90deg",
                transition: "ease 0.3s",
              }}
            />
          </button>
        </div>
        {changeProduct && (
          <div className="mt-3 row">
            <div className="col-12 col-md-6 mb-3 mb-lg-0">
              <PanelRadioButton
                id="directAdmin"
                value={`${removePanelStr} DirectAdmin`}
                checked={selectedPanel.panel?.toLowerCase().includes("directadmin") ?? false}
                onChange={panelHandler}
                icon={directAdminIcon}
                disabled={isSingapore}
              />
              {isSingapore && (
                <TooltipInfo
                  msg={`Tidak tersedia`}
                  bgColor={`#fff`}
                  placement={"right"}
                />
              )}
            </div>
            <div className="col-12 col-md-6 mb-3 mb-lg-0">
              <PanelRadioButton
                id="cpanel"
                value={`${removePanelStr} cPanel`}
                checked={selectedPanel.panel?.toLowerCase().includes("cpanel") ?? false}
                onChange={panelHandler}
                icon={cpanelIcon}
              />
            </div>
          </div>
        )}
      </div>
      <div className="row my-3">
        <div className="col-lg-8 col-12">
          <div className="col-12 mb-2">
            <label className="fw-bold">Opsi Backup:</label>
          </div>
          <div className="col-12">
            <select
              className="form-select"
              aria-label="Default select example"
              name="backup"
              id="backup"
              onChange={addBackupHandler}
              disabled={isSingapore}
            >
              {isSingapore ? (
                <>
                  <option value="Mingguan">Mingguan</option>
                </>
              ) : (
                <>
                  <option value="Mingguan">Mingguan</option>
                  <option value=" + Backup Harian">Harian</option>
                </>
              )}
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

const CollapseIcon = (props) => {
  return (
    <img
      {...props}
      src={collapseIcon}
      alt="icon.png"
      height={"auto"}
      width={12}
    />
  );
};

export default VCHOrder;
